import { ExpirationMessageService } from './../../../data/services/expiration-message'
import { ExpirationMessage } from './../../../data/models/expiration-message'
import { IOperationServiceConfig } from './../../../model-repository'
import { JsonApiProcessor } from '../../../data/services'

export const ExpirationMessageConfig: IOperationServiceConfig<ExpirationMessage> = {
  service: ExpirationMessageService,
  deps: [JsonApiProcessor],
  endpoint: 'orders/expiration_message?params[user-id]=:user_id',
  model: ExpirationMessage,
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/operation/expiration-message.config.ts